import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "../../lib/utils"

function Slider({ className, defaultValue, value, min = 0, max = 100, ...props }) {
	const values = Array.isArray(value) ? value : Array.isArray(defaultValue) ? defaultValue : [min, max]

	return (
		<SliderPrimitive.Root
			data-slot="slider"
			defaultValue={defaultValue}
			value={value}
			min={min}
			max={max}
			className={cn(
				"relative flex w-full touch-none items-center select-none py-2 data-[disabled]:opacity-50",
				className,
			)}
			{...props}
		>
			<SliderPrimitive.Track
				data-slot="slider-track"
				className="bg-black/10 dark:bg-white/15 shadow-inner relative grow overflow-hidden rounded-full h-2"
			>
				<SliderPrimitive.Range
					data-slot="slider-range"
					className="bg-primary absolute h-full rounded-full transition-[width] duration-150 ease-out"
				/>
			</SliderPrimitive.Track>
			{Array.from({ length: values.length }, (_, i) => (
				<SliderPrimitive.Thumb
					data-slot="slider-thumb"
					key={i}
					className="border-primary bg-white dark:bg-neutral-900 block size-[18px] shrink-0 rounded-full border-[3px] shadow-[0_2px_6px_rgba(0,0,0,0.25),0_0_0_4px_rgba(232,98,26,0.15)] transition-shadow duration-150 focus-visible:ring-4 focus-visible:ring-primary/30 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50"
				/>
			))}
		</SliderPrimitive.Root>
	)
}

export { Slider }
